type LogoProps = {
  color?: string;
};

export function Logo({ color = "var(--accent)" }: LogoProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="lg-top" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#c4baff" />
          <stop offset="100%" stopColor={color} />
        </linearGradient>
        <linearGradient id="lg-bot" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7c6ce0" />
        </linearGradient>
      </defs>
      {/* Back tile */}
      <path d="M 16 4 L 27 10 L 16 16 L 5 10 Z" fill="url(#lg-top)" />
      <path d="M 27 10 L 27 14 L 16 20 L 16 16 Z" fill="#7c6ce0" />
      <path d="M 5 10 L 5 14 L 16 20 L 16 16 Z" fill="#5e51c8" />
      {/* Front tile */}
      <path d="M 16 14 L 27 20 L 16 26 L 5 20 Z" fill="url(#lg-bot)" />
      <path d="M 27 20 L 27 24 L 16 30 L 16 26 Z" fill="#5e51c8" />
      <path d="M 5 20 L 5 24 L 16 30 L 16 26 Z" fill="#3f3792" />
    </svg>
  );
}
